export default class TrackerTradeDoubler {

    constructor() {
        this.enabled = false;
    }

    load() {
        if(!this.enabled) {
            this.enabled = true;

            if(window.trackerVar.montant_total_hthp > 0) {
                let newCustomer = 395581;
                if(window.trackerVar.new_customer) newCustomer = 395579;

                (function () {
                    var element = document.createElement('img');
                    element.src = "https://tbs.tradedoubler.com/report?organization=2232239"
                        + "&event=" + newCustomer 
                        + "&ordernumber=" + window.trackerVar.order_id 
                        + "&ordervalue=" + window.trackerVar.montant_total_hthp 
                        + "&currency=eur";
                    document.body.append(element);
                })();
            }

        }
    }

    sendOnPageLoad() {
        if(!this.enabled) return;
    }

}
